import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const Lines = ({ text }) => (text || "").split("\n").map((l, i) => <span key={i}>{i > 0 && <br/>}{l}</span>);

export default function Contact() {
  const { site, pages: { contact: c } } = useContent();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
      <div className="max-w-3xl">
        <div className="text-terracotta text-sm tracking-widest uppercase font-medium">{c.eyebrow}</div>
        <h1 className="mt-2 font-serif font-bold text-5xl md:text-6xl leading-tight">{c.heading}</h1>
        <p className="mt-4 text-lg text-charcoal/70">{c.description}</p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-8">
        <div className="bg-white rounded-3xl p-8 shadow-card">
          <div className="grid gap-6">
            <Item icon={MapPin} title="Studio"><span data-testid="contact-address">{site.address_line1}<br/>{site.address_line2}</span></Item>
            <Item icon={Mail} title="Email"><a href={`mailto:${site.email}`} className="text-terracotta" data-testid="contact-email">{site.email}</a></Item>
            {site.phone && <Item icon={Phone} title="Phone"><a href={`tel:${site.phone}`} className="text-terracotta" data-testid="contact-phone">{site.phone}</a></Item>}
            <Item icon={Clock} title="Hours"><span data-testid="contact-hours"><Lines text={site.hours}/></span></Item>
          </div>
        </div>
        {c.map_link && <div className="rounded-3xl overflow-hidden shadow-card h-80 md:h-auto">
          <iframe title="Studio Map" src={c.map_link} className="w-full h-full min-h-[400px] border-0"/>
        </div>}
      </div>
    </div>
  );
}

function Item({ icon: Icon, title, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="w-11 h-11 rounded-full bg-terracotta/10 grid place-items-center"><Icon size={20} className="text-terracotta" strokeWidth={1.5}/></div>
      <div>
        <div className="font-serif text-lg font-semibold">{title}</div>
        <div className="text-charcoal/75 mt-1">{children}</div>
      </div>
    </div>
  );
}
